import showToast from "common/Notification";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  addMedicineFail,
  addMedicineSuccess,
  createMedicineCategoryFail,
  createMedicineCategorySuccess,
  deleteMedicineFail,
  deleteMedicineSuccess,
  getMedicineCategoriesFail,
  getMedicineCategoriesSuccess,
  getMedicineDetailsFail,
  getMedicineDetailsSuccess,
  getMedicinesListFail,
  getMedicinesListSuccess,
  getPartMedDetailsFail,
  getPartMedDetailsSuccess,
  getTaskMedDetailsFail,
  getTaskMedDetailsSuccess,
  medDropListFail,
  medDropListSuccess,
  savePartMedDetailsFail,
  savePartMedDetailsSuccess,
  updatePartMedFail,
  updatePartMedSuccess,
  updateMedicineFail,
  updateMedicineSuccess,
  deleteMedDocSuccess,
  deleteMedDocFail,
  removeMedPartProfileSuccess,
  removeMedPartProfileFail,
  addMedListParticipantSuccess,
  addMedListParticipantFail,
  updatePartMedListSuccess,
  updatePartMedListFail,
  getTaskMedReportSuccess,
  getPartMedReportSuccess,
  getPartMedReportFail,
  getPartMedicineLogSuccess,
  getPartMedicineLogFail,
  getMedicationLogSuccess,
  getMedicationLogFail,
  getTaskMedReportFail,
} from "./actions";
import { responseHandler } from "common/CommanFunction";
import {
  ADD_MEDICINE_TO_CATEGORY,
  CREATE_MEDICINE_CATEGORY,
  DELETE_MEDICINE_OF_CATEGORY,
  GET_ADDED_MEDICINE,
  GET_MEDICINE_CATEGORIES,
  GET_MEDICINE_DETAILS,
  GET_PART_MED_DETAILS,
  GET_TASK_MED_DETAILS,
  GET_MED_DROP_LIST,
  SAVE_PART_MED_DETAILS,
  UPDATE_PART_MED_DATA,
  UPDATE_MEDICINE_OF_CATEGORY,
  DELETE_MEDICINE_DOC,
  REMOVE_MED_PART_PROFILE,
  ADD_MED_LIST_PARTICIAPNT,
  UPDATE_PART_MED_LIST,
  GET_TASK_MED_REPORT,
  GET_PARTICIPANT_MEDICATION_REPORT,
  GET_PART_MEDICINE_LOGS,
  GET_MEDICATION_LOG,
} from "./actionTypes";
import {
  onMedicationCategoryList,
  onCreatingCategory,
  onUpdatePartMed,
  onGettingMedicines,
  onAddingMedicine,
  onUpdatingMedicine,
  onDeletingMedicine,
  onGettingMedDetails,
  onGettingMedDropList,
  onGettingTaskMedDetail,
  onGettingPartMedDetails,
  onSavingPartMedDetails,
  onDeletingMedDoc,
  onRemovingPartMed,
  onAddingNewPartMed,
  onUpdatingPartMedList,
  onGettingTaskMedReport,
  onGettingPartMedREport,
  onGettingPartMedicineLog,
  onGettingMedicationLog,
} from "helpers/fakebackend_helper";

const toastTitle = "Medication";

function* onGetPartMedicineLog({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingPartMedicineLog, data);
    yield call(responseHandler, toastTitle, response, getPartMedicineLogSuccess, getPartMedicineLogFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getPartMedicineLogFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetMedicationLog({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingMedicationLog, data);
    yield call(responseHandler, toastTitle, response, getMedicationLogSuccess, getMedicationLogFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getMedicationLogFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onUpdatePartMedList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingPartMedList, data);
    yield call(responseHandler, toastTitle, response, updatePartMedListSuccess, updatePartMedListFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updatePartMedListFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetPartMedReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingPartMedREport, data);
    yield call(responseHandler, toastTitle, response, getPartMedReportSuccess, getPartMedReportFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(getPartMedReportFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetTaskMedReport({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTaskMedReport, data);
    yield call(responseHandler, toastTitle, response, getTaskMedReportSuccess, getTaskMedReportFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getTaskMedReportFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onAddNewPartMed({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingNewPartMed, data);
    yield call(responseHandler, toastTitle, response, addMedListParticipantSuccess, addMedListParticipantFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addMedListParticipantFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onRemovePartMed({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onRemovingPartMed, data);
    yield call(responseHandler, toastTitle, response, removeMedPartProfileSuccess, removeMedPartProfileFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(removeMedPartProfileFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onDeleteMedDoc({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingMedDoc, data);
    yield call(responseHandler, toastTitle, response, deleteMedDocSuccess, deleteMedDocFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteMedDocFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onSavePartMedicineDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onSavingPartMedDetails, data);
    yield call(responseHandler, toastTitle, response, savePartMedDetailsSuccess, savePartMedDetailsFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(savePartMedDetailsFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetPartMedicineDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingPartMedDetails, data);
    yield call(responseHandler, toastTitle, response, getPartMedDetailsSuccess, getPartMedDetailsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getPartMedDetailsFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetMedicineDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingMedDetails, data);
    yield call(responseHandler, toastTitle, response, getMedicineDetailsSuccess, getMedicineDetailsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getMedicineDetailsFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onUpdateMedicine({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingMedicine, data);
    yield call(responseHandler, toastTitle, response, updateMedicineSuccess, updateMedicineFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateMedicineFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onDeleteMedicine({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingMedicine, data);
    yield call(responseHandler, toastTitle, response, deleteMedicineSuccess, deleteMedicineFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteMedicineFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onAddMedicine({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddingMedicine, data);
    yield call(responseHandler, toastTitle, response, addMedicineSuccess, addMedicineFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addMedicineFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetMedicines({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingMedicines, data);
    yield call(responseHandler, toastTitle, response, getMedicinesListSuccess, getMedicinesListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getMedicinesListFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetCategories({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onMedicationCategoryList, data);
    yield call(responseHandler, toastTitle, response, getMedicineCategoriesSuccess, getMedicineCategoriesFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getMedicineCategoriesFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onCreateCategory({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onCreatingCategory, data);
    yield call(responseHandler, toastTitle, response, createMedicineCategorySuccess, createMedicineCategoryFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(createMedicineCategoryFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onUpdatePartMedData({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatePartMed, data);
    yield call(responseHandler, toastTitle, response, updatePartMedSuccess, updatePartMedFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updatePartMedFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetMedDropList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingMedDropList, data);
    yield call(responseHandler, toastTitle, response, medDropListSuccess, medDropListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(medDropListFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetTaskMedDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTaskMedDetail, data);
    yield call(responseHandler, toastTitle, response, getTaskMedDetailsSuccess, getTaskMedDetailsFail, onSuccess, onError, true, false);
  } catch (error) {
    onError();
    yield put(getTaskMedDetailsFail(error));
    showToast("error", toastTitle, error);
  }
}

function* MedicationSaga() {
  yield takeEvery(GET_MEDICATION_LOG, onGetMedicationLog);
  yield takeEvery(SAVE_PART_MED_DETAILS, onSavePartMedicineDetail);
  yield takeEvery(GET_PART_MED_DETAILS, onGetPartMedicineDetail);
  yield takeEvery(GET_MEDICINE_CATEGORIES, onGetCategories);
  yield takeEvery(CREATE_MEDICINE_CATEGORY, onCreateCategory);
  yield takeEvery(UPDATE_PART_MED_DATA, onUpdatePartMedData);
  yield takeEvery(GET_ADDED_MEDICINE, onGetMedicines);
  yield takeEvery(ADD_MEDICINE_TO_CATEGORY, onAddMedicine);
  yield takeEvery(DELETE_MEDICINE_OF_CATEGORY, onDeleteMedicine);
  yield takeEvery(UPDATE_MEDICINE_OF_CATEGORY, onUpdateMedicine);
  yield takeEvery(GET_MEDICINE_DETAILS, onGetMedicineDetail);
  yield takeEvery(GET_MED_DROP_LIST, onGetMedDropList);
  yield takeEvery(GET_TASK_MED_DETAILS, onGetTaskMedDetail);
  yield takeEvery(DELETE_MEDICINE_DOC, onDeleteMedDoc);
  yield takeEvery(REMOVE_MED_PART_PROFILE, onRemovePartMed);
  yield takeEvery(ADD_MED_LIST_PARTICIAPNT, onAddNewPartMed);
  yield takeEvery(UPDATE_PART_MED_LIST, onUpdatePartMedList);
  yield takeEvery(GET_TASK_MED_REPORT, onGetTaskMedReport);
  yield takeEvery(GET_PARTICIPANT_MEDICATION_REPORT, onGetPartMedReport);
  yield takeEvery(GET_PART_MEDICINE_LOGS, onGetPartMedicineLog);
}

export default MedicationSaga;
